import React, { useEffect, useState } from 'react';
import Logo from '../../../assets/images/logo.png';
import MoneyHeroLogo from '../../../assets/images/money-hero-icon.png';
import TopPhone from '../../../assets/images/top-phone.svg'
import UsePageTracking from '../UsePageTracking';
import { useLocation } from 'react-router-dom';

function AppHeader() {

  const [isShowNotice, setIsShowNotice] = useState(false);
  const location = useLocation();
  const [isMoneyHero, setIsMoneyHero] = useState(false);
  const isApplicationFlowPage = [
    '/application-otp',
    '/application-otp-success',
    '/application-consent',
    '/application-form-1',
    '/application-form-2-1',
    '/application-form-2-2',
    '/application-confirm-data',
    '/application-ekyc-confirm',
  ].includes(location.pathname) || location.pathname.startsWith('/quick-cash-20000/');

  useEffect(() => {
    const open = new URLSearchParams(location.search).get('open');
    setIsShowNotice(open === 'register' || open === 'quick-cash-20000');
    setIsMoneyHero(window.location.href.includes('money-hero'))
  }, [location]);

  UsePageTracking()
  return (
    <div className="relative">
      <div className={`divider-header w-full relative`}>
        <div className="z-40 relative bg-white p-4">
          <div className="flex justify-between">
            <div>
              {isApplicationFlowPage ? (
                <img style={{ width: isMoneyHero ? 300 : 140 }} src={isMoneyHero ? MoneyHeroLogo : Logo} alt="" />
              ) : (
                <a href={process.env.REACT_APP_HOME_URL}>
                  <img style={{ width: isMoneyHero ? 300 : 140 }} src={isMoneyHero ? MoneyHeroLogo : Logo} alt="" className="cursor-pointer" />
                </a>
              )}
            </div>
            {!isMoneyHero && <div className='flex justify-center items-center'>
              <a href="tel:23668859">
                <img src={TopPhone} alt="" className="cursor-pointer w-[130px]" />
              </a>
            </div>}
          </div>
        </div>
      </div>
      {isShowNotice && <div className="absolute px-4 py-1 z-50 text-[#FF852F] bg-[#ffe5d4]">
        <p className="font-bold">建議使用Google Chrome瀏覽器，享受更暢快的貸款申請體驗。</p>
      </div>}
    </div>
  );
}

export default AppHeader;
